export const PermPlus = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        {...props}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6668 8.66732H8.66683V12.6673H7.3335V8.66732H3.3335V7.33398H7.3335V3.33398H8.66683V7.33398H12.6668V8.66732Z"
        fill={props.fill}
      />
    </svg>
  );
};
